import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=107c9d72&scoped=true"
import script from "./uploadBtn.vue?vue&type=script&lang=js"
export * from "./uploadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c9d72",
  null
  
)

export default component.exports